import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrackAppPartnerRoutingModule } from './track-app-partner-routing.module';
import { TrackAppHomeComponent } from './track-app-home/track-app-home.component';
import { TrackAppErrorComponent } from './track-app-error/track-app-error.component';
import { AppTrackComponent } from './track-app-home/app-track/app-track.component';
import { RetrieveAppComponent } from './track-app-home/retrieve-app/retrieve-app.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from "../shared/shared.module";

@NgModule({
  declarations: [TrackAppHomeComponent, TrackAppErrorComponent, AppTrackComponent, RetrieveAppComponent],
  imports: [
    CommonModule,
    TrackAppPartnerRoutingModule,
    SharedModule,  
    FormsModule
  ],
  exports: [TrackAppHomeComponent, TrackAppErrorComponent, AppTrackComponent, RetrieveAppComponent]
})
export class TrackAppPartnerModule { }
